import React from "react";
import { View, StyleSheet } from "react-native";

import Text from "component/typography/Text";
import ProductImages from "component/card/ProductImages";
import AddAndChangeCartItem from "component/section/AddAndChangeCartItem";

import { colors, sizes, strings } from "asset/constant";

import { css } from "style";
import { mq, priceFormatter, sn } from "utils";
import Icon from "component/typography/Icon";

export default function CartItemCard(props: { item: CartItemT }) {
  const { item } = props;

  return (
    <View style={styles.container}>
      <View style={[css.overFlowH, css.fixFitContent]}>
        {[5, -2, 1, -4].map((num: number) => {
          return (
            <View
              key={String(num)}
              style={[
                css.fix,
                css.width(300),
                css.height(300),
                css.radius(200),
                { right: mq(num * -25), bottom: mq(-num * 30) },
                css.border(2, colors.theme + "05"),
              ]}
            />
          );
        })}
      </View>

      <View>
        <View style={[{ height: 70, flexDirection: "row" }]}>
          <View
            style={{
              ...css.container,
              justifyContent: "center",
              paddingRight: sn(60, 60, 75, 75),
            }}
          >
            <Text
              size={"xl"}
              weight="bold"
              numberOfLines={2}
              color={colors.text.dark}
              style={{ lineHeight: 23 }}
            >
              {item?.title}
            </Text>
          </View>

          <ProductImages images={item?.images} />
        </View>

        {item?.attribute_items && item?.attribute_items?.length > 0 && (
          <View
            style={{
              height: 45,
              ...css.rRowCenterAlign,
              paddingHorizontal: sizes.space,
            }}
          >
            {item?.attribute_items?.map((attr, key) => {
              return (
                <View key={String(key)}>
                  <View
                    key={String(key)}
                    style={{
                      ...css.rRowCenterAlign,
                      ...css.height(32),
                      paddingRight: mq(20),
                      ...(key === 0
                        ? {
                            borderTopRightRadius: mq(3),
                            borderBottomRightRadius: mq(15),
                          }
                        : {}),
                      ...(key + 1 === item?.attribute_items?.length
                        ? {
                            borderTopLeftRadius: mq(15),
                            borderBottomLeftRadius: mq(3),
                          }
                        : {}),
                    }}
                  >
                    <Icon name={"leftcircle"} color={colors.border.normal} />
                    <Text style={{ bottom: mq(1) }} weight="extraBold">
                      {"  "}
                      {attr.title}
                      {"  "}
                    </Text>
                  </View>
                </View>
              );
            })}
          </View>
        )}

        <View
          style={{
            padding: sizes.space / 2,
            ...css.rRowCenterAlign,
            ...css.justifySBetween,
          }}
        >
          {item?.attribute_items?.findIndex((e) => e.is_customized === 1) >
          -1 ? (
            <></>
          ) : (
            <View style={{ ...css.rRowCenterAlign, width: mq(130) }}>
              <Text color={colors.text.dark} weight="extraBold" size={18}>
                {priceFormatter(item?.price)}
              </Text>
              <Text weight="extraBold" size={"xs"}>
                {" "}
                {strings.currency}{" "}
              </Text>
            </View>
          )}

          <AddAndChangeCartItem
            step={item?.is_binary === 1 ? 2 : 1}
            id={item.id}
            inCart={true}
            count={item.count}
            productId={item.product_id}
            variations={item.attribute_items}
            desc={item.description}
          />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "94%",
    alignSelf: "center",
    marginBottom: 15,
    marginTop: sn(5, 5, 20, 30),
    ...css.shadowForWeb(10),
    backgroundColor: colors.white,
    borderRadius: sizes.radius.lg,
  },

  content: { padding: mq(8) },
});
